import React, { useEffect, useState } from "react";
import "./style.scss";
import { Select, Button, message } from "antd";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getHintByFile, updateFeedback } from "../../../Api/BatchesApi";

const FeedbackModal = ({ setShowFeedbackModal }) => {
  const [urls, setUrls] = useState([]);
  const [currentUrl, setCurrentUrl] = useState("");
  const [feedbackType, setFeedbackType] = useState();
  const [comments, setComments] = useState("");
  const [hintsList, setHintList] = useState([]);
  const [isSuccess, setIsSuccess] = useState(false);
  const {
    fileReducer: {
      activeFile,
      file,
      versions,
      commentList,
      markingData,
      markingList,
      extraImagesRawData,
      isActionable,
    },
  } = useSelector((state) => state);

  useEffect(() => {
    const fetchFeedbackHint = async () => {
      try {
        const response = await getHintByFile(file?._id);
        if (response.status === 200) {
          setHintList(response?.data?.data);
        }
      } catch (error) {
        console.error("Error fetching feedback hint:", error);
        message.error("Failed to fetch feedback hint");
      }
    };

    fetchFeedbackHint();
  }, [isSuccess]);

  const isValidUrl = (url) => {
    const urlPattern =
      /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?$/;
    return urlPattern.test(url);
  };

  const handleAddUrl = (e) => {
    if (e.key === "Enter" && currentUrl.trim()) {
      if (isValidUrl(currentUrl.trim())) {
        setUrls([...urls, currentUrl.trim()]);
        setCurrentUrl("");
      } else {
        message.error("Please enter a valid URL");
      }
      e.preventDefault();
    }
  };

  const handleRemoveUrl = (indexToRemove) => {
    setUrls(urls.filter((_, index) => index !== indexToRemove));
  };

  const handleSubmit = async () => {
    try {
      const payload = {
        filename: file?.filename,
        fileId: file?._id,
        companyCode:
          file?.companyCode || sessionStorage?.getItem("companyCode"),
        batchName: file?.batchName,
        batchId: file?.batch,
        hintText: comments,
        hintType: feedbackType,
        hintUrls: urls,
      };

      const response = await updateFeedback(payload);
      if (response.status === 200) {
        message.success(response?.data?.message);
        try {
          window.dispatchEvent(
            new CustomEvent("file-hint-updated", {
              detail: { fileId: file?._id },
            })
          );
        } catch (e) {
          console.error("Error dispatching file-hint-updated event:", e);
        }
        // setShowFeedbackModal(false);
        setIsSuccess(!isSuccess);
        setUrls([]);
        setFeedbackType("");
        setComments("");
        setCurrentUrl("");
      }
    } catch (error) {
      console.error("Submission error:", error);
      message.error(error.message || "Failed to submit feedback");
    }
  };
  function formatDateTime(isoString) {
    const date = new Date(isoString);

    const day = date.getDate().toString().padStart(2, '0');
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();

    const hours = date.getHours().toString().padStart(2, '0');
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const seconds = date.getSeconds().toString().padStart(2, '0');

    return `${day} ${monthName} ${year}, ${hours}:${minutes}:${seconds}`;
  }


  return (
    <div className="feedback_main_container">
      <div className="feedback_content_section">
        <div className="hints_list_wrapper">
          <div className="heading">History</div>

          {hintsList?.length > 0 ? (
            hintsList.map((hint, index) => (
              <div key={index} className="hint_wrapper">

                <div className="hint_data">
                  <div className="hint_heading">Feedback Type</div>
                  <div className="content">{hint?.hintType}</div>
                </div>
                <div className="hint_data">
                  <div className="hint_heading">Comments</div>
                  <div className="content">{hint?.hintText}</div>
                </div>
                <div className="hint_data">
                  <div className="hint_heading">Created At</div>
                  <div className="content">{formatDateTime(hint?.createdAt)}</div>
                </div>

                <div className="hint_data">
                  <div className="hint_heading">Created By</div>
                  <div className="content">{(hint?.createdBy?.name)}</div>
                </div>
                {hint?.hintUrls?.length > 0 && (
                  <div className="hint_data">
                    <div className="hint_heading">Links</div>
                    <div className="content">
                      {hint?.hintUrls?.length > 0 &&
                        hint.hintUrls.map((url, urlIndex) => (

                          <a
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hint_url"
                          >
                            Link {urlIndex + 1}
                          </a>

                        ))}
                    </div>
                  </div>
                )}
              </div>
            ))
          ) : (
            <div className="no_hints">No hints available</div>
          )}
        </div>
        <div className="break" />
        <div className="add-list-wrapper">
          <div className="heading">Add Hint</div>
          <div className="form_control">
            <label>
              Feedback Type
              <span>*</span>
            </label>
            <Select
              value={feedbackType}
              onChange={setFeedbackType}
              placeholder="Select feedback type"
            >
              <Select.Option value="For Future">For Future</Select.Option>
              <Select.Option value="For Reshoot">For ReShoot</Select.Option>
            </Select>
          </div>
          <div className="form_control">
            <label>
              Add Comments
              <span>*</span>
            </label>
            <textarea
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              placeholder="Enter your comments"
            />
          </div>
          <div className="form_control">
            <label>Add Links</label>
            <input
              type="url"
              value={currentUrl}
              onChange={(e) => setCurrentUrl(e.target.value)}
              onKeyDown={handleAddUrl}
              placeholder="Enter URL and press Enter"
              className="url_input"
            />
            <div className="url_list">
              {urls.map((url, index) => (
                <div key={index} className="url_item">
                  <span>{url}</span>
                  <span
                    className="remove_url"
                    onClick={() => handleRemoveUrl(index)}
                  >
                    ×
                  </span>
                </div>
              ))}
            </div>
          </div>

          <div className="form_control">
            <Button
              type="primary"
              onClick={handleSubmit}
              disabled={!feedbackType || !comments.trim()}
            >
              Add Hint
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeedbackModal;
